const placeOrderCommand = {
  execute: async (context, cartId, params) => {
    const response = await context.app.$vsf.$magento.api.placeOrder(
      { cart_id: cartId },
      params?.customQuery ?? null,
      params?.customHeaders
    );
    return response;
  }
};
export {
  placeOrderCommand
};